export const ds_DividerBlock_Entry = `
    fragment ds_DividerBlock_Entry on ds_DividerBlock_Entry {
        id
        canonicalUid
        divider_ColorPalette
        divider_ColorTheme
        divider_TopSpacing
        divider_LinePadding
        divider_ContainerWidth
        divider_FullWidthBackground
        divider_LineWeight
        divider_LineColour
        divider_LineOpacity
        divider_CentredGraphic {
            alt
            url
            width
            focalPoint
        }
        divider_GraphicSize
        divider_SpaceBetween
    }
`